function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function buildTraits(user) {
    switch(user.type){
        case "anonymous":
            return {
                userId: "",
                email: user.email,
                tenant: "",
                locale: undefined,
                roles: undefined
            };
        case "authenticted":
            return {
                userId: user.id,
                email: user.email,
                tenant: user.tenantName,
                locale: user.locale,
                roles: user.roles
            };
    }
}
function getTenant() {
    return localStorage.getItem("tenant");
}
/**
 * Initialize a placeholder analytics object on window that just logs to the console.
 *
 * @param analytics Optional analytics object to use instead of the default
 */ function logAnalyticsEventsToConsole(analytics) {
    if (window.analytics) {
        // Don't replace existing analytics object in case this is erroneously called in production
        return false;
    }
    window.analytics = analytics != null ? analytics : {
        track: console.log.bind(console, "track"),
        page: console.log.bind(console, "page"),
        identify: console.log.bind(console, "identify")
    };
    return true;
}
/**
 * Identifies the current user and provides the analytics tool some more information regarding
 * the user and the tenant. The function should be called in following cases:
 * - After a user first registers
 * - After a user logs in
 * - When a user updates their info (for example, they change tenant)
 *
 * @param user The current user
 */ function identify(user) {
    if (window.analytics) {
        const traits = buildTraits(user);
        try {
            window.analytics.identify(user.email, traits);
        } catch (error) {
            console.error(error);
        }
    }
}
/**
 * Tracks any event in the application.
 * Will try to load tenant from the "tenant" localstorage item and set as property on the event
 * This is used for group analytics
 *
 * @param event Event to be tracked
 * @param properties Other relevant properties for the event
 * @returns
 */ function track(event, properties) {
    if (!window.analytics) {
        return;
    }
    try {
        const tenant = getTenant();
        window.analytics.track(event, _extends({}, properties, {
            tenant
        }));
    } catch (error) {
        console.error(error);
    }
}
/**
 * Tracks a visit to a page.
 *
 * @param name Name of the page
 * @param properties Other relevant properties for the page
 */ function page(category, name, properties) {
    if (!window.analytics) {
        return;
    }
    try {
        const tenant = getTenant();
        window.analytics.page(category, name, _extends({}, properties, {
            tenant
        }));
    } catch (error) {
        console.error(error);
    }
}

export { identify, logAnalyticsEventsToConsole, page, track };
